import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {
    CancelWithdrawalMutationMutation,
    CancelWithdrawalMutationMutationVariables,
    GetOpenWithdrawalsQuery
} from "../../../../gql/graphql";
import {GET_OPEN_WITHDRAWALS} from "../../../../store/queries/GetOpenWithdrawals";
import {UseQuerySuspense} from "../../../../components/UseQuerySuspense/UseQuerySuspense";
import {Typography} from "@mui/material";
import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import CurrencyFormatter from "../../../../components/CurrencyFormatter/CurrencyFormatter";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import {LoadingButton} from "@mui/lab";
import {CANCEL_WITHDRAWAL_MUTATION} from "../../../../store/mutations/CancelWithdrawal";
import {GET_USER} from "../../../../store/queries/GetUser";
import {format} from "date-fns";

export const OpenWithdrawals = () => {
    const {t} = useTranslation();
    const openWithdrawals = useQuery<GetOpenWithdrawalsQuery>(GET_OPEN_WITHDRAWALS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });
    const [commitCancelWithdrawal, cancelWithdrawalState] = useMutation<CancelWithdrawalMutationMutation, CancelWithdrawalMutationMutationVariables>(CANCEL_WITHDRAWAL_MUTATION,
        {
            update(cache, {data}) {
                cache.writeQuery({
                    data: {identity: data?.cancelWithdrawal},
                    query: GET_USER
                });
            }
        });

    const cancelWithdrawal = (id?: string, amount?: number) => {
        if (!id) return;
        
        commitCancelWithdrawal({
            variables: {
                withdrawalId: id
            },
            onCompleted(data) {
                (window as any).dataLayer = (window as any).dataLayer || [];
                (window as any).dataLayer.push({
                    'event': 'cancelWithdrawSuccess',
                    'value': amount,
                    'currency': 'EUR'
                });
                openWithdrawals.refetch();
            },
            onError(data) {

            }
        })
    };

    if (openWithdrawals.data?.openWithdrawals && openWithdrawals.data?.openWithdrawals.length > 0)
        return (
            <UseQuerySuspense data={openWithdrawals}>
                <Typography>
                    <Typography variant={'h5'} sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        minHeight: 64
                    }}>{t('openWithdrawals')}</Typography>
                </Typography>
                <TableContainer component={Paper} sx={{p: 2, maxWidth: 1}}>
                    <Table size="small" aria-label="transactions">
                        <TableHead sx={{
                            '& > tr > th': {
                                borderBottom: 'none',
                                backgroundColor: '#F4F6F8',
                                fontWeight: 600,
                                whiteSpace: 'nowrap'
                            },
                            '& > tr > th:first-of-type': {
                                borderTopLeftRadius: '8px',
                                borderBottomLeftRadius: '8px',
                            },
                            '& > tr > th:last-of-type': {
                                borderTopRightRadius: '8px',
                                borderBottomRightRadius: '8px',
                            }
                        }}>
                            <TableRow>
                                <TableCell>{t('timestamp')}</TableCell>
                                <TableCell align="right">{t('amount')}</TableCell>
                                <TableCell></TableCell>
                                {/*<TableCell align="right">{t('balanceAfter')}</TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{
                            '& > tr:last-child > td': {
                                borderBottom: 'none'
                            }
                        }}>
                            {openWithdrawals.data.openWithdrawals.map(withdrawal => (
                                <TableRow>
                                    <TableCell>{format(new Date(withdrawal?.timeStamp), 'yyyy-MM-dd HH:mm:ss')}</TableCell>
                                    <TableCell align="right">
                                        <CurrencyFormatter quantity={withdrawal?.amount} currency={'EUR'}/>
                                    </TableCell>
                                    <TableCell>
                                        <LoadingButton loading={cancelWithdrawalState.loading}
                                                       onClick={() => cancelWithdrawal(withdrawal?.id, withdrawal?.amount)}>{t('cancel')}</LoadingButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </UseQuerySuspense>
        )
    else
        return <></>
}